import classNames from "classnames";
import { useState } from "react";

const Switch = ({
  switchFor,
  label,
  helper,
  defaultChecked = true,
  onChange,
}: any) => {
  const [checked, setChecked] = useState(defaultChecked);

  const handleChange = (e: any) => {
    setChecked((prev: any) => !prev);
    onChange(e);
  };

  return (
    <>
      <label className="flex gap-3 my-4 cursor-pointer" htmlFor={switchFor}>
        <input
          className="hidden"
          type="checkbox"
          name={switchFor}
          id={switchFor}
          checked={checked}
          onChange={handleChange}
        />
        <div
          className={classNames(
            "mt-0.5 relative shadow min-w-[38px] h-[20px] rounded-full",
            {
              "bg-blue-600": checked,
              "bg-gray-300": !checked,
            }
          )}
        >
          <div
            className={classNames(
              "absolute top-0.5 w-[16px] h-[16px] bg-white rounded-full transition-all",
              {
                "left-[calc(100%-19px)]": checked,
                "left-[3px]": !checked,
              }
            )}
          ></div>
        </div>
        <div>
          <div className="text-sm font-semibold">{label}</div>
          <div className="text-xs text-gray-500">{helper}</div>
        </div>
      </label>
    </>
  );
};
export default Switch;
